var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTmBug = function SvgTmBug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 18.958c-4.941 0-8.958-4.016-8.958-8.958S5.059 1.042 10 1.042c4.942 0 8.959 4.016 8.959 8.958S14.942 18.958 10 18.958m0-16.666C5.75 2.291 2.292 5.75 2.292 10S5.75 17.708 10 17.708 17.71 14.25 17.71 10 14.25 2.292 10 2.292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 11.458a.63.63 0 0 1-.625-.625V6.667A.63.63 0 0 1 10 6.042a.63.63 0 0 1 .625.625v4.166a.63.63 0 0 1-.625.625M10 14.167a.8.8 0 0 1-.316-.067 1 1 0 0 1-.275-.175.9.9 0 0 1-.175-.275.8.8 0 0 1-.067-.316.8.8 0 0 1 .067-.317q.062-.15.175-.275a1 1 0 0 1 .275-.175.83.83 0 0 1 .633 0q.15.063.275.175a1 1 0 0 1 .175.275q.065.152.067.317a.8.8 0 0 1-.067.316.9.9 0 0 1-.175.275 1 1 0 0 1-.275.175.8.8 0 0 1-.317.067"
  })));
};
export default SvgTmBug;